<template>
  <div class="keyAreaMonitor" ref="keyAreaMonitor">
    <div class="tltle">
      <div @click="watchAll()" class="lookAll">查看全部</div>
    </div>
    <div class="videoBox" @click="watchAll()">
      <div class="video1">
        <div v-if="oneImg">
          <img :src="oneImg" alt />
        </div>
       <div v-else>
         <template v-if="customerId == 17">
           <img src="./img/3.png" alt />
         </template>
         <template v-else-if="customerId == 15">
           <img src="./img/15_1.jpg" alt />
         </template>
         <template v-else-if="customerId == 53">
           <img src="./img/13.jpg" alt />
         </template>
         <template v-else-if="customerId == 57">
           <img src="./img/5.jpg" alt />
         </template>
         <template v-else-if="customerId == 73">
           <img src="./img/7.jpg" alt />
         </template>
         <template v-else-if="customerId == 68">
           <img src="./img/9.jpg" alt />
         </template>
         <template v-else-if="customerId == 60">
           <img src="./img/11.jpg" alt />
         </template>
         <template v-else-if="customerId == 22">
           <img src="./img/17.jpg" alt />
         </template>
         <template v-else-if="customerId == 3">
           <img src="./img/18.jpg" alt />
         </template>
         <template v-else-if="customerId == 78">
           <img src="./img/20.jpg" alt />
         </template>
         <template v-else-if="customerId == 46">
           <img src="./img/22.jpg" alt />
         </template>
         <template v-else-if="customerId == 77">
           <img src="./img/77_1.jpg" alt="" />
         </template>
         <template v-else-if="customerId == 61">
           <img src="./img/61_1.jpg" alt="" />
         </template>
         <template v-else-if="customerId == 67">
           <img src="./img/67_1.jpg" alt="" />
         </template>
         <template v-else-if="customerId == 83">
           <img src="./img/83_1.jpg" alt="" />
         </template>
         <template v-else-if="customerId == 40">
           <img src="./img/40_1.jpg" alt="" />
         </template>
         <template v-else-if="customerId == 99">
           <img src="./img/99_1.png" alt="" />
         </template>
         <template v-else-if="customerId == 144">
           <img src="./img/144_1.png" alt="" />
         </template>
         <template v-else-if="customerId == 88">
           <img src="./img/88_1.png" alt="" />
         </template>
         <template v-else>
           <img src="./img/1.png" alt />
         </template>
       </div>
      </div>
      <div class="video2">
        <div v-if="twoImg">
          <img  :src="twoImg" alt />
        </div>
        <div v-else>
          <template v-if="customerId == 17">
            <img src="./img/4.png" alt />
          </template>
          <template v-if="customerId == 21">
            <img src="./img/15.jpg" alt />
          </template>
          <template v-else-if="customerId == 15">
            <img src="./img/15_2.jpg" alt />
          </template>
          <template v-else-if="customerId == 53">
            <img src="./img/14.jpg" alt />
          </template>
          <template v-else-if="customerId == 57">
            <img src="./img/6.jpg" alt />
          </template>
          <template v-else-if="customerId == 73">
            <img src="./img/8.jpg" alt />
          </template>
          <template v-else-if="customerId == 68">
            <img src="./img/10.jpg" alt />
          </template>
          <template v-else-if="customerId == 60">
            <img src="./img/12.jpg" alt />
          </template>
          <template v-else-if="customerId == 22">
            <img src="./img/16.jpg" alt />
          </template>
          <template v-else-if="customerId == 3">
            <img src="./img/19.jpg" alt />
          </template>
          <template v-else-if="customerId == 78">
            <img src="./img/21.jpg" alt />
          </template>
          <template v-else-if="customerId == 46">
            <img src="./img/23.jpg" alt />
          </template>
          <template v-else-if="customerId == 77">
            <img src="./img/77_2.jpg" alt="" />
          </template>
          <template v-else-if="customerId == 61">
            <img src="./img/61_2.jpg" alt="" />
          </template>
          <template v-else-if="customerId == 67">
            <img src="./img/67_2.jpg" alt="" />
          </template>
          <template v-else-if="customerId == 83">
            <img src="./img/83_2.jpg" alt="" />
          </template>
          <template v-else-if="customerId == 40">
            <img src="./img/40_2.jpg" alt="" />
          </template>
          <template v-else-if="customerId == 99">
            <img src="./img/99_2.png" alt="" />
          </template>
          <template v-else-if="customerId == 144">
            <img src="./img/144_2.png" alt="" />
          </template>
          <template v-else-if="customerId == 88">
           <img src="./img/88_2.png" alt="" />
         </template>
          <template v-else>
            <img src="./img/2.png" alt />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import mybus from "@/utils/eventbus";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {
      pageInfo: 'keyAreaMonitor.vue',
      computedName: '重点区域监控组件',
      customerId: this.$store.state.customerId,
      videoList: [],
      oneImg: '',
      twoImg: ''
    };
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.keyAreaMonitor).outerWidth();
    let h = $(that.$refs.keyAreaMonitor).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    if(this.customerId !== 92 && this.customerId !=94 && window.bmeConfig.getVideoImg) {
      this.getVideoImg();
    }
    mybus.$on("showAllVideo", (val) => {
      if (val == true) {
        that.watchAll();
      }
    });
  },
  //方法集合
  methods: {
    getVideoImg() {
      const url = CONFIG.requestName + this.$apiOpt.getVideoImg;
      const params = {
        customerId: this.customerId
      }
      this.$apiUtils.get(url, params).then(res=>{
        this.videoList = res;
        res.forEach(item=>{
          if(item.imgIpChannel == '1,1') {
            this.oneImg = item.ossUrl;
          }
          if(item.imgIpChannel == '2,1') {
            this.twoImg = item.ossUrl;
          }
        })
      });
    },
    watchAll() {
      console.log(bmeConfig.isQiniuyunRtc)
      if (bmeConfig.isQiniuyunRtc) {
        this.$store.commit("changeVideoSquareNewSwitch", "open");
      } else {
        this.$store.commit("changeVideoSquareSwitch", "open");
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
.keyAreaMonitor {
  width: 600px;
  height: 250px;
  .tltle {
    display: flex;
    position: relative;
    width: 100%;
    height: 24px;
    justify-content: flex-end;
    .home_number {
      margin-right: 290px;
    }
    .lookAll {
      cursor: pointer;
      margin-right: 21px;
      height: 24px;
      font-size: 18px;
      color: #4be0ff;
      line-height: 24px;
    }
  }
  .videoBox {
    //@include bg-box(558px, 172px, "movie.png");
    cursor: pointer;
    white-space: nowrap;
    display: flex;
    padding-top: 15px;
    margin: 0 auto;
    margin-top: 10px;
    .video1 {
      width: 274px;
      height: 142px;
      margin-right: 10px;
      div {
        width: 274px;
        height: 142px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .video2 {
      width: 274px;
      height: 142px;
      div {
        width: 274px;
        height: 142px;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>
